import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LocalStorage } from '../_api/localstorage';
import { NotificationService } from './notification.service';
declare var webGlObject: any;
export enum CaseTypeEnum {
    Concelmeant = 1,
    Faurd = 2,
    Money = 3,
    Company= 4,
}

//1 تحت الاجراء
//2	محفوظة
//3	مرسلة للجنه
//4	مرسلة للنيابة
//5	موقوفة عن البت
export enum CaseStatusEnum {
    UnderAction = 1,
    Saved = 2,
    SendToCommittee = 3,
    SendToPres = 4,
    Stoped = 5,
}
//1 البيانات الاساسية
//2	التحري
//3	التفتيش والضبط
//4	سماع الاقوال
//5 التقرير
//6 اعتماد التقرير
//7 منتهية
/// 50	انشاء القضية
// 51	استكمال بيانات القضية
// 52	استدعاءات و سماع الأقوال
// 53	كتابة التقرير
// 54	اعتماد التقرير
// 55	منتهية
export enum CaseStageEnum{
    MainData = 1,
    investigation = 2,
    Inspection = 3,
    Recalls = 4,
    Report = 5,
    ReportApproval = 6,
    Finished = 7,
    F_Create = 50,
    F_CompleteData = 51,
    F_Recalls = 52,
    F_ReportAdd = 53,
    F_ReportApproval = 54,
    F_Finished = 55,
    Proscution = 100,
    ActionTakenAfterResponse = 101,
    ProscutionCommittee = 300, 
    Committee = 200,
}


@Injectable({
    providedIn: 'root'
})
export class SharedHttpService {
    baseUrl: string = "ht0/";
    correspondanceDetailsObj: any;
    closeResult: string;
    CurrentRoleId: any = 0;
    CurrentUserId: any = 0;
    CurrentFullRoleName: any = "";
    CurrentCommitteeId = 0;
    CurrentOrganizationId = 0;
    CurrentUserRoleId: any = 0;

   /* permissions: any = [];*/

    // get CurrentUserRoleId(): any {
    //     return
    // }
    //get CurrentFullRoleName(): any {
    //    return JSON.parse(localStorage.getItem("user")).userId;
    //}
    get permissions ():  any {
        if (localStorage.getItem("user") != null && localStorage.getItem("user") != "null" && JSON.parse(localStorage.getItem("user")).prs !=null)
           return JSON.parse(localStorage.getItem("user")).prs;
        else
           return [];
    }

    get crp(): any {
        if (localStorage.getItem("user") != null && localStorage.getItem("user") != "null" && JSON.parse(localStorage.getItem("user")).crp != null)
            return JSON.parse(localStorage.getItem("user")).crp;
        else
            return [];
    }
    get CurrentUser(): any {
        return JSON.parse(localStorage.getItem("user"));
    }
    // get CurrentUserId(): any {
    //     return JSON.parse(localStorage.getItem("user")).userId;
    // }
    constructor(private modalService: NgbModal, private toastr: NotificationService, private http: HttpClient, private translate: TranslateService) {
        let wegObj = new webGlObject();
        this.baseUrl = wegObj.baseUrl;
        this.onreload();
    }

    onreload() {


        try {
            let user = JSON.parse(localStorage.getItem("user"));
            this.CurrentUserId = user.userId;

            if (this.CurrentUserRoleId == null || this.CurrentUserRoleId ==0   ) {


                let rolesArr = user.userRoles;
                rolesArr.forEach(r => {
                    if (r.lastSelected == true) {
                        this.CurrentUserRoleId = r.userRoleId;
                        this.CurrentRoleId = r.roleId;
                        if (r.organizationId != null) {
                            this.CurrentOrganizationId = r.organizationId;
                            this.CurrentCommitteeId = null;
                        }


                        if (r.committeeId != null) {
                            this.CurrentOrganizationId = null;
                            this.CurrentCommitteeId = r.committeeId;
                        }


                        if (r.committeeId != null && r.organizationId != null) {
                            this.CurrentCommitteeId = null;
                            this.CurrentOrganizationId = null;



                        }


                    }
                });

            }
        }
        catch   {

        }
    
 
    }
    hasPermission(code: string): boolean {
        return (this.permissions.indexOf(code) > -1);
    };

  


    hasCasePermission(code: string,   type:any): boolean {
        let crparr = this.crp;
        for (let i = 0; i < crparr.length; i++) {
            if (crparr[i].p === code && crparr[i].c === type) {
                return true;
            }
        }
        return false;
    };
    get(url: any): Observable<any> {
        return this.http.get<any>(this.baseUrl + url);
    }
    post(url: any, data: any): Observable<any> {
        return this.http.post<any>(this.baseUrl + url, data);
    }
    put(url: any, data: any): Observable<any> {
        return this.http.put<any>(this.baseUrl + url, data);
    }

    delete(url, data): Observable<any> {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            body: data,
        };
        return this.http.delete<any>(this.baseUrl + url, options);
    }
    deleteAtt(url): Observable<any> {
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
            }),
            // body: data,
        };
        return this.http.delete<any>(this.baseUrl + url, options);
    }
    downloadFileGet(url: any): Observable<any> {
        return this.http.get(this.baseUrl + url, { responseType: 'arraybuffer' });
    }
    TranslateKey(key: any): Observable<any> {
        return this.translate.get(key);
    }



    showErrorKey(Key: any) {
        this.translate.get(Key).subscribe(x => {
            this.toastr.showError(x, "خطأ");
        });
    }

    showSuccessKey(Key: any) {
        this.translate.get(Key).subscribe(x => {
            this.toastr.showSuccess(x, "");
        });
    }


    //popup
    openLarge(content: any) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
    openXLarge(content: any) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'xl' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }
    openSmall(content: any) {
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }
    convertDateToNgbDateStruct(dateString) {
        let date = new Date(dateString);


        if (date.getDate() == 1) {

            return { day: date.getDate(), month: date.getUTCMonth() + 2, year: date.getUTCFullYear() };
        }

        else {
            return { day: date.getDate(), month: date.getUTCMonth() + 1, year: date.getUTCFullYear() };
        }

    }

   
    parseArabic2(str: string) {
        let x = str
            .split("٠").join("0")
            .split("١").join("1")
            .split("٢").join("2")
            .split("٣").join("3")
            .split("٤").join("4")
            .split("٥").join("5")
            .split("٦").join("6")
            .split("٧").join("7")
            .split("٨").join("8")
            .split("٩").join("9");
        return x;
    }
    getString(url: any): Observable<any> {
        return this.http.get(this.baseUrl + url, { responseType: 'text' });
    }




    isValidSaudiID(saudiID: string  ) :boolean  {
        const stringID = this.easternToWesternNumbers(saudiID.toString()).trim();

        if (
            stringID.length !== 10 ||
            !this.isNumeric(stringID) ||
            !"12".includes(stringID[0])
        ) {
            return false;
        }

        let sum = 0;
        for (let idx = 0; idx < stringID.length; idx++) {
            if (idx % 2 === 0) {
                sum += this.evaluateDigit(Number(stringID[idx]));
            } else {
                sum += Number(stringID[idx]);
            }
        }

        return sum % 10 === 0;
    }

      evaluateDigit = (currentDigit: number) => {
        if (currentDigit < 5) {
            return currentDigit * 2;
        }
        const sum = (currentDigit * 2).toString();
        return Number(sum[0]) + Number(sum[1]);
    };


      easternToWesternNumbers = (nums: string) =>
        nums.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d).toString());

        isNumeric = (str: any) => {
        if (typeof str !== "string") {
            return false;
        }
        return [...str].every((char: string) => "0123456789".includes(char))
    }




   
}
